import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { normalize } from '../../../../../components/SearchForm/components/AirportsWidget/utils/normalize.js';
const MIN_LENGTH_VALUE = 3;
export const useFilteredAirports = (input, airports) => {
  const {
    t
  } = useTranslation();
  const flattenedAirports = useMemo(() => airports.flatMap(group => group.airports ? group.airports : group.children ? group.children.flatMap(child => child.airports || []) : []), [airports]);
  const filteredAirports = useMemo(() => {
    const searchValue = normalize(input);
    if (searchValue.length < MIN_LENGTH_VALUE) return [];
    const normalizedAirports = flattenedAirports.map(airport => ({
      ...airport,
      normalizedCode: normalize(airport?.code),
      normalizedAirport: normalize(t(`airportsWidget:options.${airport?.code?.toUpperCase()}.name`) || airport?.code)
    }));
    return normalizedAirports.filter(airport => {
      return airport.normalizedCode.includes(searchValue) || airport.normalizedAirport.includes(searchValue);
    }).sort((a, b) => {
      return (b.normalizedCode.startsWith(searchValue) ? 1 : 0) - (a.normalizedCode.startsWith(searchValue) ? 1 : 0);
    }).map(airport => ({
      ...airport,
      code: airport?.code || '',
      nearby: airport?.nearby?.sort((a, b) => Number(a.distance) - Number(b.distance))
    }));
  }, [input, flattenedAirports, t]);
  return {
    filteredAirports,
    noMatch: input.length >= MIN_LENGTH_VALUE && filteredAirports.length === 0
  };
};